const mapQueryParams = (url: string, queryParams: { [key: string]: string }): string => {
  let ret: string = url;
  const keys = Object.keys(queryParams);
  if (!keys.length) return ret;
  const mappedParams = keys.map(key => `${key}=${queryParams[key]}`).join('&');
  return `${ret}?${mappedParams}`;
}

const httpHelpers = {
  mapQueryParams,
}

export default httpHelpers;
